import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getRandomBusinessTask, submitReview } from "../../api/reviewApi";
import Button from "../../components/common/Button";
import TextInput from "../../components/common/TextInput";
import { useAuth } from "../../hooks/useAuth";
import { getFileUrl } from './../../utils/fileUrl';
import { FiArrowLeft } from "react-icons/fi";

const CATEGORY_LABELS = {
  restaurant: "Restaurant",
  hotel: "Hotel",
  gym: "Gym",
};

function ReviewPage() {
  const { category } = useParams(); // "restaurant" | "hotel" | "gym"
  const navigate = useNavigate();
  const { user } = useAuth();
  const userId = user.user_id

  const [business, setBusiness] = useState(null);
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [form, setForm] = useState({
    ans_a: "",
    ans_b: "",
    ans_c: "",
    rating: 5,
    review_text: "",


  });

  const [wordCount, setWordCount] = useState(0);


  const catKey = category?.toUpperCase(); // "RESTAURANT"/"HOTEL"/"GYM"
  const catLabel = CATEGORY_LABELS[category] || "Review";

  useEffect(() => {
    async function loadTask() {
      setLoading(true);
      setError("");
      setSuccess("");
      try {

        const data = await getRandomBusinessTask(catKey, userId);
        if (!data.success) {
          setError(data.message || "Failed to load task.");
          return;
        }
        setBusiness(data.business);
        setImages(data.images || []);
      } catch (err) {
        console.error(err);
        setError(
          err.response?.data?.message ||
            "Failed to load task or your limit might be over."
        );
      } finally {
        setLoading(false);
      }
    }

    if (catKey) {
      
      loadTask();
    } else {
      
      setError("Invalid category.");
      setLoading(false);
    }
  }, [catKey, userId]);

  //const images = business?.images || [];

  const hasImages = images.length > 0;

    // Questions by type
  const getQuestions = () => {
    const type = catKey;
    if (type === "RESTAURANT") {
      return [
        {
          key: "ans_a",
          label: "Food quality",
          helper: "1 = very bad, 5 = excellent",
        },
        {
          key: "ans_b",
          label: "Service & staff behavior",
          helper: "1 = very bad, 5 = excellent",
        },
        {
          key: "ans_c",
          label: "Environment",
          helper: "1 = very bad, 5 = excellent",
        },
      ];
    }

    // HOTEL / GYM
    return [
      {
        key: "ans_a",
        label: "Facilities & equipment condition",
        helper: "1 = very bad, 5 = excellent",
      },
      {
        key: "ans_b",
        label: "Staff behavior & support",
        helper: "1 = very bad, 5 = excellent",
      },
      {
        key: "ans_c",
        label: "Cleanliness & safety",
        helper: "1 = very bad, 5 = excellent",
      },
    ];
  };

  const questions = getQuestions();

  const limit = 20

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "review_text"){
      const senteance = value
      const currentLetter = senteance.length
      //const words = value.trim().split(/\s+/).filter(Boolean);
      //const currentWords = words.length;

    if (currentLetter <= limit ) {
      // Update state only if we are within the limit or the field is empty
      //setText(rawText);
      //setWordCount(currentWords);
      setWordCount(currentLetter)
    } 
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isSubmitDisabled = wordCount < limit;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!business) {
      setError("No task loaded.");
      return;
    }

    try {
      const payload = {
        business_id: business.business_id,
        ans_a: form.ans_a,
        ans_b: form.ans_b,
        ans_c: form.ans_c,
        rating: Number(form.rating),
        review_text: form.review_text,
        user_id: userId
      };


      const data = await submitReview(payload);
      if (!data.success) {
        setError(data.message || "Failed to submit review.");
        return;
      }

      setSuccess("Review submitted successfully.");
      // Optionally, disable form or redirect
      //navigate(`/review/${category}`); // if you want to go back home
      window.location.reload()
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          "Submit failed. Your daily limit may be over."
      );
    }
  };

    const currentImage = hasImages ? images[imageIndex] : null;

  const nextImage = () => {
    if (!hasImages) return;
    setImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    if (!hasImages) return;
    setImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // if (loadingBusiness) {
  //   return <div>Loading business...</div>;
  // }

  if (loading) {
    return <div>Loading {catLabel} task...</div>;
  }

  if (error) {
    return (
      <div className="space-y-4">
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
          {error}
        </div>
        <Button onClick={() => navigate("/")}>Back to Home</Button>
      </div>
    );
  }

  if (!business) {
    return (
      <div className="space-y-4">
        <div>No task available.</div>
        <Button onClick={() => navigate("/")}>Back to Home</Button>
      </div>
    );
  }



    return (
    <div className="space-y-6">
      {/* Back to wallet */}
      <div className="animate-fadeIn">
        <Link
          to="/"
          className="inline-flex items-center text-sm text-gray-600 hover:text-primary-600 transition-colors"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Link>
      </div>
      {/* Header + back */}
      <div className="animate-fadeIn">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            Review {business.name}
          </h1>
          <p className="text-gray-600 mt-1">
            Type: {business.type}  • Reward per approved review:{" "}
            <span className="font-semibold">€0.20</span>
          </p>
          {/* {stats && (
            <p className="text-[11px] text-slate-500 mt-1">
              Today: {todayCount}/{dailyLimit} reviews used (
              {remaining < 0 ? 0 : remaining} remaining)
            </p>
          )} */}
        </div>
      </div>

      {/* Status/daily limit messages */}
      {/* {isNewAccount && (
        <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-800">
          Your current status is{" "}
          <span className="font-semibold">New Account</span>. If you wanted to
          start working / income / reviewing, please update your status by refer
          other.
        </div>
      )} */}

      {/* {!isNewAccount && overDailyLimit && (
        <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-800">
          {statusLevel === STATUS_LEVEL.GOLD
            ? "Your daily limit is over. Thanks for complete the all review tasks."
            : "Your daily limit is over. If you wanted to more submit, update your status by review other."}
        </div>
      )} */}

      {/* {statsError && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-[11px] text-red-700">
          {statsError}
        </div>
      )} */}

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-[11px] text-red-700">
          {error}
        </div>
      )}

      {success && (
        <div className="rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-[11px] text-emerald-700">
          {success}
        </div>
      )}

      {/* Main content: left image, right form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Image / business info */}
        <div className="space-y-3">
          <div className="rounded-xl border bg-white shadow-sm overflow-hidden">
            <div className="relative h-56 bg-slate-100">
              {currentImage ? (
                <img
                  
                  src={getFileUrl(currentImage.image_url)}
                  alt={business.name}
                  className="h-full w-full object-cover"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center text-xs text-slate-400">
                  No image
                </div>
              )}
              {hasImages && (
                <>
                  <button
                    type="button"
                    onClick={prevImage}
                    className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 px-2 py-1 text-[11px] text-white"
                  >
                    ←
                  </button>
                  <button
                    type="button"
                    onClick={nextImage}
                    className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 px-2 py-1 text-[11px] text-white"
                  >
                    →
                  </button>
                  <div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 gap-1">
                    {images.map((img, idx) => (
                      <button
                        key={img.business_images_id}
                        type="button"
                        onClick={() => setImageIndex(idx)}
                        className={
                          "h-1.5 rounded-full " +
                          (idx === imageIndex
                            ? "w-4 bg-white"
                            : "w-2 bg-white/60")
                        }
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="p-3 space-y-1">
              <div className="text-sm font-semibold text-slate-900">
                {business.name}
              </div>
              <div className="text-[11px] text-slate-500">
                {business.address}
              </div>
              <div className="text-[11px] text-slate-500">
                Google rating:{" "}
                {business.google_start ? (
                  <span className="font-medium">
                    ⭐ {business.google_start}
                  </span>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>

          {/* Info about review rules */}
          <div className="rounded-md border border-slate-200 bg-white px-3 py-2 text-[12px] text-slate-900 space-y-1">
            <div>
              • Each approved review adds <b>€0.20</b> to your wallet.
            </div>
            <div>
              • You can review the same business <b>only once per day</b>.
            </div>
            <div>
              • Daily limits depend on your account status (Activated/Bronze: 5,
              Silver: 10, Gold: 15). Backend strictly checks this.
            </div>
          </div>
        </div>

        {/* Review form */}
        <div className="rounded-xl border bg-white shadow-sm p-4 space-y-3">
          <form className="space-y-3" onSubmit={handleSubmit}>
            {/* Questions A, B, C */}
            {questions.map((q, idx) => (
              <div key={q.key} className="space-y-1">
                <div className="text-xs font-medium text-slate-800">
                  Q{idx + 1}. {q.label}
                </div>
                <div className="flex items-center gap-2 text-[11px] text-slate-600">
                  <span>Rating:</span>
                  {[1, 2, 3, 4, 5].map((value) => (
                    <label
                      key={value}
                      className="inline-flex items-center gap-1"
                    >
                      <input
                        type="radio"
                        name={q.key}
                        value={value}
                        checked={String(form[q.key]) === String(value)}
                        onChange={handleChange}
                        // disabled={!canSubmitReview}
                      />
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
                <div className="text-[11px] text-slate-500">{q.helper}</div>
              </div>
            ))}

            {/* Overall rating */}
            <div className="space-y-1">
              <div className="text-xs font-medium text-slate-800">
                {/* Overall rating for this {getTypeLabel(business.type)} */}
              </div>
              <div className="flex items-center gap-2 text-[11px] text-slate-600">
                <span>Rating:</span>
                {[1, 2, 3, 4, 5].map((value) => (
                  <label
                    key={value}
                    className="inline-flex items-center gap-1"
                  >
                    <input
                      type="radio"
                      name="rating"
                      value={value}
                      checked={String(form.rating) === String(value)}
                      onChange={handleChange}
                      // disabled={!canSubmitReview}
                    />
                    <span>{value}★</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Text review */}
            <div className="space-y-1">
              <label className="block text-xs font-medium text-slate-800">
                Write your review (optional but recommended)
              </label>
              <textarea
                name="review_text"
                value={form.review_text}
                onChange={handleChange}
                rows={4}
                className="w-full rounded-md border border-slate-300 px-3 py-2 text-xs outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-900/10"
                placeholder="Describe your experience. Please be honest and specific."
                // disabled={!canSubmitReview}
              />

              <p>
        Letter Count: {wordCount} / {limit}
      </p>
      
            </div>

            <Button
              type="submit"
              disabled={isSubmitDisabled}
              className="w-full md:w-auto mt-2"
            >
              Submit Review
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ReviewPage;
